(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  document.querySelectorAll('[data-oh-collection-intro-toggle]').forEach((btn) => {
    const content = btn.previousElementSibling;
    if (!content || !content.hasAttribute('data-oh-collection-intro')) return;
    if (content.scrollHeight <= content.clientHeight + 4) return;
    btn.hidden = false;
    btn.addEventListener('click', () => {
      const expanded = content.classList.toggle('collection-hero__description--expanded');
      btn.querySelector('[data-label-more]').hidden = expanded;
      btn.querySelector('[data-label-less]').hidden = !expanded;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.querySelectorAll('[data-oh-product-description-toggle]').forEach((btn) => {
  const content = btn.previousElementSibling;
  if (!content || !content.hasAttribute('data-oh-product-description')) return;
  if (content.scrollHeight <= content.clientHeight + 4) return;
  btn.hidden = false;
  btn.addEventListener('click', () => {
    const expanded = content.classList.toggle('oh-product-description--expanded');
    btn.querySelector('[data-label-more]').hidden = expanded;
    btn.querySelector('[data-label-less]').hidden = !expanded;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oh-texte-seo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.oh-texte-seo__toggle').forEach((btn) => {
    const content = btn.previousElementSibling;
    const labelMore = btn.querySelector('[data-label-more]');
    const labelLess = btn.querySelector('[data-label-less]');
    if (content.scrollHeight <= content.clientHeight + 4) return;
    btn.hidden = false;
    btn.addEventListener('click', () => {
      const expanded = content.classList.toggle('oh-texte-seo__content--expanded');
      labelMore.hidden = expanded;
      labelLess.hidden = !expanded;
      if (!expanded) {
        content.scrollIntoView({ block: 'nearest' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('read-more-text')) {
    customElements.define(
      'read-more-text',
      class ReadMoreText extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('.rich-text__read-more-toggle');
          this.content = this.querySelector('.rich-text__text--collapsible');
          if (!this.button || !this.content) return;
          this.button.addEventListener('click', this.toggle.bind(this));
        }

        toggle() {
          const isExpanded = this.content.classList.toggle('rich-text__text--expanded');
          this.button.setAttribute('aria-expanded', isExpanded);
          this.button
            .querySelector('.rich-text__read-more-label--more')
            .classList.toggle('hidden', isExpanded);
          this.button
            .querySelector('.rich-text__read-more-label--less')
            .classList.toggle('hidden', !isExpanded);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
